export default class FinancePartnerModel {
  FinancePartnerId: number;
  FinancePartnerName: string;
  InterestRate: number;
  MinimumDownPayment: number;
  ContactPerson1: string;
  ContactPhone1: string;
  ContactPerson2: string;
  ContactPhone2: string;
  EmailId: string;
  Sequance: number;
}
